export default {
    key: 'pintenfritz',
    common: {
        productName: 'core.productNames.pintenfritz',
        splashMessage: 'offerFlow.splashMessage.pintenfritz',
        headingAside: 'offerFlow.headingAside.pintenfritz',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.pintenfritz',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.activity',
        body: 'offerFlow.pages.stepPassengers.body.common',
    },
} satisfies OfferFlowContent;
